import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Devuelve una función que vuelve a la ventana inmediatamente anterior del
 * historial del navegador. Si no hay historia previa (entrada directa por URL,
 * recarga, o pestaña nueva), navega al `fallback` indicado.
 *
 * Combinado con la persistencia de filtros/búsqueda/orden en URL params del
 * DataTable, esto restaura el listado tal cual lo dejó el usuario antes de
 * entrar a la ficha.
 */
export function useVolver(fallback: string | (() => string)): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    // react-router guarda un índice incremental en history.state.idx.
    // 0 = entrada inicial de la sesión; >0 = hay algo a lo que volver.
    const idx = (window.history.state as { idx?: number } | null)?.idx;
    if (typeof idx === 'number' && idx > 0) {
      navigate(-1);
    } else {
      navigate(typeof fallback === 'function' ? fallback() : fallback);
    }
  }, [navigate, fallback]);
}
